import clone from 'clone-deep';
import { RunStep } from '../../app/core/models/run-step.model';

// because we cannot spy on named imports and it is to much work to really fake the functionality we have to use a class for this function
export class StepDeepCloneUtil {
    static getDeepClonedSteps(runSteps: RunStep[]): RunStep[] {
        return clone(runSteps, true);
    }
}
